import { render, staticRenderFns } from "./studioDashboardWebsiteContent.vue?vue&type=template&id=5cdbe015&scoped=true"
import script from "./studioDashboardWebsiteContent.vue?vue&type=script&lang=js"
export * from "./studioDashboardWebsiteContent.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardWebsiteContent.vue?vue&type=style&index=0&id=5cdbe015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdbe015",
  null
  
)

export default component.exports